import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { usePresenter } from "./presenter";
import Title from "./components/Title/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const presenter = usePresenter();
const { model } = presenter;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Title, {
      onUpdate: _unref(presenter).handleUpdate
    }, null, 8, ["onUpdate"])
  ]))
}
}

})